/**
 * Replace content of DOM elements
 * @param {Object} content - DOM element
 * @param {String} selector - selector to replace with content
 * @param {Boolean} fullReplace - flag indicating whether the element should be replaced in its entirety
 * 
 * @return {Void}
 */
const replace = function(content, selector, fullReplace) {
  const el = [...document.querySelectorAll(selector)];

  if (el.length > 0) {
    el.forEach(item => {
      if (fullReplace) {
        item.outerHTML = content.toString() || '';
      } else {
        item.innerHTML = content.toString() || '';
      }
    });
  }
};
export default replace;
